import _ from "lodash";

/**
 * Genera montos de honorarios (solo asistencias + legajos) por profesional y liquidación
 * @param {Array} asistencias
 * @param {Array} legajos
 * @param {number|string} idLiquidacion
 * @returns {Array<{ idUsuario:number, idLiquidacion:number|string, monto:number }>}
 */
export const generarProfesionalesPorLiquidacion = (asistencias, legajos, idLiquidacion, NombrePaciente) => {
  const registros = [];
  // 🔹 Asistencias
  asistencias
    .filter((a) => a.parahonorario === "SI" && a.asignado)
    .forEach((a) => {
      registros.push({
        idUsuario: a.asignado,
        idLiquidacion,
        NombrePaciente,
        monto: Number(a.honorario) || 0,
      });
    });

  // 🔹 Legajos
  legajos
    .filter((l) => l.paraHonorario === "SI" && l.IdUsuario)
    .forEach((l) => {
      const monto =
        Number(l.CostoHoraProfesional) *
          (Number(Number(l.horashoraextra).toFixed(2)) + (l.horascalculadas || 0)) +
        (Number(l.CostoHoraProfesional) * (l.horasferiado || 0) * (l.porcentajeferiado || 0)) / 100;

      registros.push({
        idUsuario: l.IdUsuario,
        idLiquidacion,
        NombrePaciente,
        monto: Math.round(monto),
      });
    });

  // 🔹 Agrupar por (profesional + liquidación)
  const agrupados = _(registros)
    .groupBy((r) => `${r.idUsuario}_${r.idLiquidacion}`)
    .map((items) => ({
      idUsuario: items[0].idUsuario,
      NombrePaciente:NombrePaciente,
      idLiquidacion: items[0].idLiquidacion,
      monto: _.sumBy(items, "monto"),
    }))
    .value();

  return agrupados;
};
